var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "100",
      "fill": "#2196F3"
    }
  }), _c('path', {
    attrs: {
      "d": "M100 0C155.228 0 200 44.772 200 100C200 155.228 155.228 200 100 200V0Z",
      "fill": "#1E7FCE"
    }
  }), _c('rect', {
    attrs: {
      "x": "40",
      "y": "64",
      "width": "120",
      "height": "72",
      "rx": "8",
      "fill": "#FFF6E8"
    }
  }), _c('path', {
    attrs: {
      "d": "M40 64l60 40 60-40",
      "fill": "#E8D4B8"
    }
  }), _c('path', {
    attrs: {
      "d": "M40 64l60 40 60-40",
      "fill": "none",
      "stroke": "#2A3B4F",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "opacity": "0.45"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }